module.exports = __webpack_public_path__ + "img/avatar3.f82950d6.jpg";